// Payload builders for the AI configuration screens. Prompts are ONE pair per
// feature (system_prompt + user_prompt); the backend picks the language from a
// `LANGUAGE: en|ar` line it adds to the user message. The legacy en_/ar_ prompt
// keys must never be sent.

const trimmedOrEmpty = (v) => (typeof v === "string" ? v : "");

export const hasStoredPrompt = (config) =>
  Boolean(
    trimmedOrEmpty(config?.system_prompt).trim() &&
      trimmedOrEmpty(config?.user_prompt).trim()
  );

export const requiredPromptRule = (label) => ({
  validator: (_, value) =>
    typeof value === "string" && value.trim()
      ? Promise.resolve()
      : Promise.reject(new Error(`${label} is required`)),
});

// We always render with the LLM in this admin panel; the deterministic Python
// renderer is not exposed, so every save pins use_deterministic_renderer false.
export const buildConfigPayload = (values, { includeFeatureName = false } = {}) => {
  const payload = {
    provider: values.provider,
    model_version: values.model_version,
    temperature: values.temperature,
    max_tokens: values.max_tokens,
    top_p: values.top_p,
    frequency_penalty: values.frequency_penalty,
    presence_penalty: values.presence_penalty,
    system_prompt: values.system_prompt,
    user_prompt: values.user_prompt,
    enabled: values.enabled,
    use_deterministic_renderer: false,
  };
  return includeFeatureName
    ? { feature_name: values.feature_name, ...payload }
    : payload;
};

export const buildPlaygroundSavePayload = (formValues, config) => ({
  provider: formValues.provider,
  model_version: formValues.model_version,
  system_prompt: formValues.system_prompt ?? "",
  user_prompt: formValues.user_prompt ?? "",
  // preserve numeric/flag fields from the original config
  temperature: config?.temperature ?? 0,
  max_tokens: config?.max_tokens ?? 0,
  top_p: config?.top_p ?? 0,
  frequency_penalty: config?.frequency_penalty ?? 0,
  presence_penalty: config?.presence_penalty ?? 0,
  enabled: config?.enabled ?? true,
  use_deterministic_renderer: false,
});

export const buildPlaygroundTestPayload = (values, featureName) => ({
  feature_name: featureName,
  test_content: values.test_content,
  language: values.language,
  provider_override: values.provider,
  model_override: values.model_version,
  system_prompt_override: values.system_prompt,
  user_prompt_override: values.user_prompt,
});
